exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-088bbb80]{background-color:#fff}tr.odd[data-v-088bbb80]{background-color:#f9f9f9}tr>td[data-v-088bbb80]{padding:10px 15px;border-top:1px solid #eee}tr:first-child>td[data-v-088bbb80]{border-top:none}tr[data-v-088bbb80]:hover{background-color:rgba(0,0,0,.1);cursor:pointer}", ""]);

// exports
